import { render, staticRenderFns } from "./analysisDetails_backup.vue?vue&type=template&id=630d81d2&scoped=true&"
import script from "./analysisDetails_backup.vue?vue&type=script&lang=js&"
export * from "./analysisDetails_backup.vue?vue&type=script&lang=js&"
import style0 from "./analysisDetails_backup.vue?vue&type=style&index=0&id=630d81d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d81d2",
  null
  
)

export default component.exports